import {Avatar, Progress} from "antd";
import {UserOutlined} from "@ant-design/icons";
import {FaChevronRight} from "react-icons/fa";
import React from "react";

export const ProfileStepsContent = ({colorBar, percent, profileLinks, currentStep,handleNextStatus, profileInfo}) => {

    const getPseudonym = (email) => {
        if (typeof email !== 'string') return '';
        return email.split('@')[0] || '';
    }

    return (
        <>
            <div className={"profile__steps__avatar"}>
                <Progress
                    size={170}
                    percent={percent}
                    type="circle"
                    strokeColor={colorBar}
                    format={() => <Avatar size={140} icon={(profileInfo?.urlProfileImage ? null : <UserOutlined />)} src={(profileInfo?.urlProfileImage ? profileInfo?.urlProfileImage : null)} />}
                />
                {
                    (profileInfo?.firstName !== " ") ?
                        <>
                            <h4>{profileInfo?.nickname ? profileInfo?.nickname : profileInfo?.firstName + " " +profileInfo?.lastName}</h4>
                            <h5>
                                {profileInfo?.nickname ? profileInfo?.firstName + " " +profileInfo?.lastName : null }
                            </h5>
                        </>
                        :
                        <>
                            <h4>
                                {(profileInfo?.firstName !== " ") ? profileInfo?.firstName : "@" + getPseudonym(profileInfo?.email) ?? ""}
                            </h4>
                            <h5>
                                {(profileInfo?.nickname !== "") ? profileInfo?.nickname : "" ?? ""}
                            </h5>
                        </>
                }

            </div>
            <div className={"profile__steps__content"}>
                <ul>
                    {profileLinks.map((item, index) => {
                        const isCompleted = item.step < currentStep;
                        const isCurrent = item.step === currentStep;
                        const isFuture = item.step > currentStep;

                        let iconRight = null;
                        if (isCompleted) {
                            iconRight =  <svg className="checkmark" viewBox="0 0 52 52">
                                <circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
                                <path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
                            </svg>;
                        } else if (isCurrent) {
                            iconRight = <FaChevronRight />;
                        }

                        const content = (
                            <>
                                <div className="link__text">
                                    <i>{item.icon}</i>
                                    <p>
                                        Paso {item.step}: {item.title}
                                        <span>{item.subtitle}</span>
                                    </p>
                                </div>
                                {iconRight && <i className="arrow">{iconRight}</i>}
                            </>
                        );

                        const linkClass = `link ${
                            isCompleted ? "completed" : isFuture ? "disabled" : ""
                        }`;

                        return (
                            <li key={index}>
                                {isCurrent ? (
                                    <div className={linkClass} onClick={() => handleNextStatus(item.status,item.step)}>
                                        {content}
                                    </div>
                                ) : (
                                    <div className={linkClass}>
                                        {content}
                                    </div>
                                )}
                            </li>
                        )
                    })}
                </ul>
            </div>
        </>
    );
}